export default __webpack_public_path__ + "static/hero-c05a2e655b8eaa05a83bab834ffcb913.jpg";